// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oWeZ","clinicsSelect":"styles_clinicsSelect__1hm2I"};